import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface UndeployModalProps {
  isOpen: boolean;
  onClose: () => void;
  liveStrategyUndeploy: () => void;
}

const UndeployModal = ({
  isOpen,
  onClose,
  liveStrategyUndeploy,
}: UndeployModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Important</DialogTitle>
        </DialogHeader>
        <p>
          Undeploying will trigger a market order to close all open positions at
          the next best available price.
        </p>
        <p>
          Please note that there may be a delay in platform data updating as the
          positions are being closed, so stats may not reconcile immediately.
        </p>
        <p>
          Additionally, if there are any positions that are not able to be
          closed at the expected price due to current market conditions, they
          may remain open longer than anticipated.
        </p>
        <p>Contact the team if you have any questions before proceeding.</p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              liveStrategyUndeploy();
              onClose();
            }}
          >
            Undeploy now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UndeployModal;
